import React from 'react'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { Button, Box } from '@mui/material'
import LoginIcon from '@mui/icons-material/Login'
import { AUTH, REGISTER_USER } from '../../config/routeType'
import { AUTHENTICATION_ROUTE } from '../../config/routes'
import { MAIN } from '../../config/routes'
import { PUBLIC_SIGNUP_ENABLED } from '../../config/featureFlags'
import AccountBoxIcon from '@mui/icons-material/AccountBox'
import logoRight from '../../assets/images/unl/logo-unl-white.png'
import logoLeft from '../../assets/images/unl/logo-arbol-ec.png'
import './css/LoginPage.css'

const LoginPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const handleClickLogin = () => navigate(AUTH)
  const handleClickRegisterUser = () => navigate(REGISTER_USER)
  const handleOnClickIcon = () => navigate(MAIN)

  return (
    <div className="auth-content">
      {/* Logo izquierdo - oculto si altura < 750px */}
      <Box
        component="img"
        src={logoLeft}
        alt="Logo ÁrbolEc"
        onClick={handleOnClickIcon}
        sx={{
          position: 'fixed',
          top: { xs: 16, sm: 24, md: 32, lg: 32, xl: 40 },
          left: { xs: 16, sm: 32, md: 48 },
          height: { xs: 45, sm: 55, md: 75, lg: 85, xl: 120 },
          maxWidth: '40vw',
          objectFit: 'contain',
          zIndex: 2,
          cursor: 'pointer',
          '@media (max-height: 749px)': {
            display: 'none',
          },
        }}
      />

      {/* Logo derecho - oculto si altura < 750px */}
      <Box
        component="img"
        src={logoRight}
        alt="Logo UNL"
        sx={{
          position: 'fixed',
          top: { xs: 0, sm: 1, md: 2 },
          right: { xs: 16, sm: 32, md: 48 },
          height: { xs: 80, sm: 100, md: 130, lg: 150, xl: 195 },
          maxWidth: '40vw',
          objectFit: 'contain',
          zIndex: 2,
          '@media (max-height: 749px)': {
            display: 'none',
          },
        }}
      />

      {/* Contenido principal sin interferencias */}
      <div className="auth-form-content">
        {location.pathname === AUTHENTICATION_ROUTE && (
          <Box display="flex" justifyContent="center">
            <Box pr={PUBLIC_SIGNUP_ENABLED ? 2 : 0}>
              <Button
                variant="contained"
                startIcon={<LoginIcon />}
                onClick={handleClickLogin}
                sx={theme => ({
                  backgroundColor: theme.palette.primary.main,
                  fontWeight: 600,
                  fontSize: '0.8rem',
                })}>
                Iniciar Sesión
              </Button>
            </Box>
            {PUBLIC_SIGNUP_ENABLED && (
              <Box>
                <Button
                  variant="contained"
                  startIcon={<AccountBoxIcon />}
                  onClick={handleClickRegisterUser}
                  sx={theme => ({
                    backgroundColor: theme.palette.primary.main,
                    fontWeight: 600,
                    fontSize: '0.8rem',
                  })}>
                  Crear Cuenta
                </Button>
              </Box>
            )}
          </Box>
        )}
        <Outlet />
      </div>
    </div>
  )
}

export default LoginPage
